import * as React from 'react';
import { CheckboxField } from '../../../../core/components';
import { DataTable } from '../../../../core/components/Table/types/DataTable';
import { DataTableHeader } from '../../../../core/components/Table/types/DataTableHeader';
import { CommunicationAcceptanceItem } from '../types/CommunicationAcceptanceItem';

const getTableColumns = (
  table: DataTable<CommunicationAcceptanceItem>,
  onAcceptanceChange: (item: CommunicationAcceptanceItem) => void
) => {
  let columns: DataTableHeader[] = [
    {
      headerName: 'acceptanceId',
      columnName: 'acceptanceId',
      isVisible: false,
    },
  ];

  if (table.headers != null) {
    columns = [...table.headers];
    configureActions(columns, onAcceptanceChange);
    return columns;
  }

  return columns;
};

const configureActions = (
  columns: DataTableHeader[],
  onAcceptanceChange: (item: CommunicationAcceptanceItem) => void
) => {
  const column = columns.find((x: DataTableHeader) => x.columnName === 'acceptance');
  if (column) {
    column.formatter = (value: any, rowItem: CommunicationAcceptanceItem) => {
      return (
        <CheckboxField
          id={rowItem.typeTranslation}
          checked={rowItem.isAcceptanceGiven}
          name={`IsAcceptanceGiven_${rowItem.acceptanceId}`}
          onChange={() => {
            onAcceptanceChange(rowItem);
          }}
        />
      );
    };
  }
};

export const TableConfigurator = {
  getTableColumns,
};
